import { render, staticRenderFns } from "./FooterView.vue?vue&type=template&id=6ad79e2c&scoped=true"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"
import style0 from "./FooterView.vue?vue&type=style&index=0&id=6ad79e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad79e2c",
  null
  
)

export default component.exports